import { render, staticRenderFns } from "./AssetSymbol.vue?vue&type=template&id=12cb57be"
import script from "./AssetSymbol.vue?vue&type=script&lang=js"
export * from "./AssetSymbol.vue?vue&type=script&lang=js"
import style0 from "./AssetSymbol.vue?vue&type=style&index=0&id=12cb57be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports